export default "__VITE_ASSET__BUHPDpJq__"